import { Component, OnInit } from '@angular/core';
import { UserManagementService } from '../../../core/services/user-management.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef } from '@angular/material/dialog';

import { ConfirmationModalService, ModalTemplateComponent } from '@nx-ahs/shared/components';

@Component({
	selector: 'app-download-roles',
	templateUrl: './download-roles.component.html',
	styleUrls: ['./download-roles.component.scss'],
	standalone: true,
	imports: [ModalTemplateComponent]
})
export class DownloadRolesComponent implements OnInit {
	public downloading: boolean;

	constructor(
		private userManagementService: UserManagementService,
		private snackBar: MatSnackBar,
		private dialogRef: MatDialogRef<DownloadRolesComponent>,
		private confirmationModalService: ConfirmationModalService
	) {}

	ngOnInit() {
		this.dialogRef.keydownEvents().subscribe((event) => {
			if (event.key === 'Escape') {
				this.cancel();
			}
		});
		this.dialogRef.backdropClick().subscribe(() => {
			this.cancel();
		});
	}

	public downloadFile(): void {
		this.downloading = true;
		this.userManagementService.downloadRoles().finally(() => {
			this.downloading = false;
			this.snackBar.open('Your file is downloading.', 'DISMISS', { duration: 5000 });
			this.dialogRef.close();
		});
	}

	public cancel(): void {
		this.confirmationModalService
			.showConfirmationDialog('Confirm Cancel', 'Click OK to continue')
			.beforeClosed()
			.toPromise()
			.then((result) => {
				if (result) {
					this.dialogRef.close(undefined);
				}
			});
	}
}
